import { render, staticRenderFns } from "./RepoList.vue?vue&type=template&id=405e3356&scoped=true&"
import script from "./RepoList.vue?vue&type=script&lang=js&"
export * from "./RepoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e3356",
  null
  
)

export default component.exports